import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';
import map from 'lodash/map';
import moment from 'moment';
import isString from 'lodash/isString';
import {serverToDisplayTime, serverToDisplayDate, serverDateFormat, serverTimeFormat} from 'app/lib/format';
import {Table} from 'routes/app/components';
import './style.scss';

const Pivot = ({data:{data, labels, timeLabel, grandTotal, totals, type}}) => {
    const now = moment();
    const inThePast = map(data, entry => {
       return moment(entry.date + entry.time, serverDateFormat + serverTimeFormat) < now;
    });

    return (
        <div className="pivot">
            <Table striped>
                <thead>
                <tr>
                    <td className="pivot__label">{timeLabel}</td>
                    {map(data, (entry, c) => (
                        <td key={`${type}-column-${c}`} className={inThePast[c] && 'pivot__column__past'}>
                            <div className="pivot__date">{entry.date && serverToDisplayDate(entry.date)}</div>
                            <div className="pivot__time">{entry.time && serverToDisplayTime(entry.time)}</div>
                        </td>
                    ))}
                    <th className="pivot__total" rowSpan={2}><FormattedMessage id="total"/></th>
                </tr>
                <tr>
                    <td />
                    {map(data, (entry, c) => (
                        <th key={`${type}-column-${c}`} className={inThePast[c] && 'pivot__column__past'}>
                            <div className="pivot__name">{entry.name}</div>
                        </th>
                    ))}
                </tr>
                </thead>
                <tbody>
                {map(labels, (label, index) => (
                    <tr key={`${type}-row-${index}`}>
                        <td className="pivot__label">{label}</td>
                        {map(data, (entry, i) => (
                            <td key={`${type}-rc-${index}-${i}`} className={inThePast[i] && 'pivot__column__past'}>
                                {entry.values[index]}
                            </td>
                        ))}
                        <td className="pivot__total">{totals[index]}</td>
                    </tr>
                ))}
                </tbody>
                <tfoot className="pivot__total pivot__total-column">
                <tr>
                    <td className="pivot__label"><FormattedMessage id="total"/></td>
                    {map(data, (entry, c) => (
                        <td key={`${type}-foot-${c}`}>{entry.total}</td>
                    ))}
                    <td>{grandTotal}</td>
                </tr>
                </tfoot>
            </Table>
        </div>
    );
};

Pivot.propTypes = {
    data: PropTypes.shape({
        type: PropTypes.number,
        timeLabel: PropTypes.string,
        labels: PropTypes.array,
        data: PropTypes.array,
        totals: PropTypes.array,
        grandTotal: PropTypes.number
    })
};

export default Pivot;